import { ValidationError, Validator } from 'class-validator';
import i18next from 'i18next';

export default class ObjectValidator {
  public errors: ValidationError[] = [];
  private validator: Validator;
  private t: any;

  constructor() {
    this.validator = new Validator();
    this.t = i18next.t.bind(i18next);
  }

  public validate(validators: Function[]): ValidationError[] {
    validators.forEach(x => x());
    return this.errors;
  }

  public isEmptyValidator(value: any, label: string, text: string) {
    return () => {
      if (this.validator.isEmpty(value)) {
        console.log(label + value);
        this.addError(label, 'isEmpty', this.t(text));
      }
    };
  }

  public isFalsyValidator(value: any, label: string, text: string) {
    return () => {
      if (!value) {
        this.addError(label, 'isNull', this.t(text));
      }
    };
  }

  public isEmailInValid(value: any, label: string, text: string) {
    return () => {
      if (!this.validator.isEmpty(value) && !this.validator.isEmail(value)) {
        this.addError(label, 'isEmail', this.t(text));
      }
    };
  }

  private addError(property: string, constraintType: string, message: string): void {
    const errorExisting = this.errors.find(err => err.property === property);
    if (errorExisting) {
      errorExisting.constraints[constraintType] = message;
    } else {
      this.errors.push({
        property,
        constraints: { [constraintType]: message },
        children: [],
      });
    }
  }
}
